export const chatMessagesListWidth = 580
export const chatMessageListBottomMargin = 10
